// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_ff","advertDetailParameterList__header":"c-q_fg","advertDetailParameterList__list":"c-q_fh"};